import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { CollapseInfo } from 'pages/SignupPage/Signup2/components/SelfLoanForTUErrors/components/CollapseInfo/CollapseInfo';
import { Link } from 'components/navigation/Link/Link';
import { ReactComponent as ChevronUp } from 'style/_assets/icons/chevron-up.svg';
import { ReactComponent as ChevronDown } from 'style/_assets/icons/chevron-down.svg';
import { Image } from 'components/Image/Image';
import {
  DEBT_RELIEF_VERTICAL,
  CREDIT_CARD_VERTICAL,
  PERSONAL_LOAN_VERTICAL,
} from 'types/mrph.vertical.constants';
import { useConfig } from 'hook/config.hook';

const actionsYouCanTake = [
  {
    title: 'Stop spending on this card',
    subtitle:
      'Spending more on this card increases your credit utilization and this should be avoided.',
  },
  {
    title: 'Pay down balances quickly',
    subtitle:
      'Reducing or eliminating your balance also lowers your credit utilization.',
  },
  {
    title: 'Request a credit limit increase',
    subtitle:
      'Raising your credit limit without increasing spending lowers your credit utilization. Contact your card issuer and ask about raising your credit limit.',
  },
  {
    title: 'Apply for a balance transfer card',
    subtitle:
      'Moving your balance to a new card with an introductory offer of a year or longer at 0 percent APR is typically a lower-cost solution that gives you time to pay down the balance without monthly interest charges during the initial period. Be sure to check the card provider’s terms are better for you before applying.',

    takeAction: {
      type: 'BALANCE_TRANSFER',
      title: 'Balance transfer cards',
      icon: <Image className={'balanceTransferIcon'} />,
      link: '/offers/creditcard?creditCardType=BALANCE_TRANSFER',
      description: 'See Balance Transfer Cards',
      vertical: CREDIT_CARD_VERTICAL,
      clickTile: 'Balance Transfer Cards',
    },
  },
  {
    title: 'Consider refinancing credit card debt',
    subtitle:
      'Credit card interest rates are very high. If you can find a credit card with a lower rate, you might lower the cost of your debt. A personal loan is also an option that can offer a cheaper rate.',
    takeAction: {
      title: 'Explore personal loans',
      icon: <Image className={'explorePersonalLoansIcon'} />,
      link: '/offers?vertical=PERSONAL_LOAN',
      vertical: PERSONAL_LOAN_VERTICAL,
      clickTile: 'Explore Personal Loans',
    },
  },
  {
    title: 'Manage your debt',
    subtitle:
      'If you have multiple credit card balances, debt management can be an option and can help. This could help you both lower your interest rate and organize your payments.',
    takeAction: {
      title: 'Debt management options',
      icon: <Image className={'manageYourDebtIcon'} />,
      link: '/actions/DEBT_RELIEF',
      vertical: DEBT_RELIEF_VERTICAL,
      clickTile: 'Debt Management Options',
    },
    showCondition: config => config?.showDebtOffers,
  },
];

const ActionsYouCanTake = props => {
  const { config } = useConfig();
  return (
    <FlexContainer
      className={'margT12 padL48 padR48 m-padL16 m-padR16 flex-column'}
    >
      <Label className={'H4 mH5 margT40 m-margT20'}>
        {'Actions you can take'}
      </Label>
      <Label className={'Body-1 mBody-2  margT16'}>
        {
          'Successfully completing one or more of these actions may improve your credit usage and may help your credit score.'
        }
      </Label>
      {actionsYouCanTake
        ?.filter(
          action => !action.showCondition || action.showCondition(config),
        )
        .map(action => {
          return (
            <>
              <CollapseInfo
                title={
                  <Label className={'Subtitle-1 mSubtitle-1'}>
                    {action.title}
                  </Label>
                }
                context={
                  <TakeActionBox
                    subtitle={action.subtitle}
                    takeAction={action.takeAction}
                    listLinkCallback={props.listLinkCallback}
                    creditInfo={props.creditInfo}
                  />
                }
                iconUp={<ChevronUp />}
                iconDown={<ChevronDown />}
                removePadding
              />
              <div className="bgGray050" style={{ height: '1px' }}></div>
            </>
          );
        })}
    </FlexContainer>
  );
};

const TakeActionBox = props => {
  const { subtitle, takeAction, listLinkCallback, creditInfo } = props;
  let showTakeAction = takeAction;
  if (
    takeAction?.type === 'BALANCE_TRANSFER' &&
    creditInfo?.creditScore < 650
  ) {
    showTakeAction = false;
  }
  return (
    <>
      <Label className={'Body-1 mBody-2   margB16'}>{subtitle}</Label>
      {showTakeAction && (
        <Link
          to={takeAction.link}
          onClickCallback={listLinkCallback}
          link={takeAction?.description}
          Vertical={takeAction?.vertical}
          clickTile={takeAction.clickTile}
        >
          <FlexContainer
            className={
              'bgGray0 format100 margB16 border-rad10px  padTB8 padLR16 align-items-center justify-between'
            }
            style={{ height: '72px' }}
          >
            {takeAction?.icon}
            <div className="margL14" style={{ width: '330px' }}>
              <Label className={'subTitle1 mSubtitle-1 secondary_text_light'}>
                {takeAction?.title}
              </Label>
            </div>

            <Image className={'rightArrowIcon'} />
          </FlexContainer>
        </Link>
      )}
    </>
  );
};

export default ActionsYouCanTake;
